module.exports = __webpack_public_path__ + "img/yellow.c05e2d81.png";